import PBService from "@irati/utils/services"
import {
  BasketInputItem,
  BasketPaymentDetailsInput,
  BasketTotalWithBreakDown,
  Checkout,
  PaymentProvider,
  BasketDiscountType
} from "@irati/types"
import client, {QueryOptions} from "@irati/utils/services/apollo"

import checkoutTotalsQuery, {checkoutTotalsKey} from "./queries/checkoutTotals"
import startCheckout, {startCheckoutKey} from "./mutations/startCheckout"
import completeCheckout, {completeCheckoutKey} from "./mutations/completeCheckout"
import checkoutQuery, {checkoutKey} from "./queries/checkout"
import {checkoutErrorHandler} from "./errors/checkoutErrorHandler"

class CheckoutService extends PBService {
  total(
    items: BasketInputItem[],
    paymentDetails?: BasketPaymentDetailsInput,
    options: QueryOptions = {}
  ): Promise<BasketTotalWithBreakDown> {
    const variables = {
      items,
      paymentDetails
    }
    return client.query({...options, fetchPolicy: "network-only", query: checkoutTotalsQuery, variables}).then(({data}) => {
      return data?.[checkoutTotalsKey]
    })
  }

  totalWithZipRate(items: BasketInputItem[], options: QueryOptions = {}): Promise<BasketTotalWithBreakDown> {
    return this.total(items, {provider: PaymentProvider.Zip}, options)
  }

  totalWithCashback(items: BasketInputItem[], options: QueryOptions = {}): Promise<BasketTotalWithBreakDown> {
    return this.total(items, {discountType: BasketDiscountType.Cashback}, options)
  }

  startCheckout(userId: string, options: QueryOptions = {}): Promise<Checkout> {
    const variables = {
      userId
    }
    return client.mutate({...options, mutation: startCheckout, variables}).then(({data}) => data[startCheckoutKey])
  }

  completeCheckout(checkoutId: string, options: QueryOptions = {}): Promise<Checkout> {
    const variables = {
      checkoutId
    }
    return client.mutate({...options, mutation: completeCheckout, variables}).then(({data}) => data[completeCheckoutKey])
  }

  getCheckout(checkoutId: string, options: QueryOptions = {}): Promise<Checkout> {
    const variables = {
      checkoutId
    }

    return client.query({...options, query: checkoutQuery, variables}).then(({data}) => data[checkoutKey])
  }
}

const checkoutService = new CheckoutService({errorHandlers: [checkoutErrorHandler]})

export default checkoutService
